import { Box, Typography } from '@mui/material'
import { RouteProps } from '../../routes/AppRouter'
import styles from './PrivacyPolicy.module.css'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { HeaderPolicy } from '../../components/header-policy/HeaderPolicy'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'
import { LoggedUser } from '../../modules/users/models/LoggedUser'
import { getUserContainer } from '../../container/user-module'
import { ILoggedUserService } from '../../modules/users/services/LoggedUserService'
import { LOGGED_USER_SERVICE_KEY } from '../../modules/users'
import genericStyle from '../../common/utils/generic.module.css'
import { useIsOpenMenuLeftContext } from '../../common/utils/isOpenMenuLeftContext'
import styleMain from '../layout/Main.module.css'
import logoCareme from '../../assets/caremePlusLogo.svg'

const loggedUserService = getUserContainer().get<ILoggedUserService>(LOGGED_USER_SERVICE_KEY)

export function PrivacyPolicy(props: RouteProps) {
  const loggedUser = loggedUserService.get()
  const title = props.title || ''
  const [user, setUser] = useState<LoggedUser | undefined>(loggedUser)
  const { setTitle } = useTitleHeaderContext()
  const openMenuLeft = useIsOpenMenuLeftContext()
  const innerWidth = window.innerWidth

  setTitle(title)
  const { t } = useTranslation()

  useEffect(() => {
    loggedUserService.getObservable().subscribe((lu) => {
      setUser(lu)
    })
  }, [])

  return (
    <>
      {user ? (
        <>
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              marginLeft: innerWidth > 900 ? (openMenuLeft ? '50px' : '') : '',
            }}
          >
            <Box
              style={{
                maxWidth:
                  innerWidth > 900
                    ? openMenuLeft
                      ? 'calc(100% - 250px)'
                      : 'calc(100% - 300px)'
                    : '95%',
                position: 'relative',
              }}
              className={genericStyle.pageContainer}
            >
              <Box sx={{ overflow: 'auto' }} className={genericStyle.container}>
                <Box className={styles.containterLogin}>
                  <Box display={'flex'} justifyContent={'center'}>
                    <Box className={styles.contentLogin}>
                      <h4 className={styles.titleParrafLogin}>{t('DataControllerTitle')}</h4>
                      <Typography className={styles.parraphLogin}>
                        {t('DataControllerParraf')}
                      </Typography>
                      <h4 className={styles.titleParrafLogin}>{t('areaOfAplicationTitle')}</h4>
                      <Typography className={styles.parraphLogin}>
                        {t('areaOfAplicationParraf')}
                      </Typography>
                      <h4 className={styles.titleParrafLogin}>{t('PurposesTheCollectiontitle')}</h4>
                      <Typography className={styles.parraphLogin}>
                        {t('PurposesTheCollectionParraf')}
                      </Typography>
                      <h4 className={styles.titleParrafLogin}>{t('PeriodConservationTitle')}</h4>
                      <Typography className={styles.parraphLogin}>
                        {t('PeriodConservationParraf')}
                      </Typography>
                      <h4 className={styles.titleParrafLogin}>
                        {t('RecipientsPersonalDataTitle')}
                      </h4>
                      <Typography className={styles.parraphLogin}>
                        {t('RecipientsPersonalDataParraf')}
                      </Typography>
                      <h4 className={styles.titleParrafLogin}>{t('RightOfUsersTitle')}</h4>
                      <Typography className={styles.parraphLogin}>
                        {t('RightOfUsersParraf')}
                      </Typography>
                      <h4 className={styles.titleParrafLogin}>{t('ControlAuthorityTitle')}</h4>
                      <Typography className={styles.parraphLogin}>
                        {t('ControlAuthorityParraf')}
                      </Typography>
                      <h4 className={styles.titleParrafLogin}>{t('AicrumitDataProcessorTitle')}</h4>
                      <Typography className={styles.parraphLogin}>
                        {t('AicrumitDataProcessorParraf')}
                      </Typography>
                      <h4 className={styles.titleParrafLogin}>{t('InfoDataProtectionTitle')}</h4>
                      <Typography className={styles.parraphLogin}>
                        {t('InfoDataProtectionParraf')}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </div>
          <Box display={'flex'} justifyContent={'flex-end'}>
            <img src={logoCareme} alt="Logo Careme" className={styleMain.logo} />
          </Box>
        </>
      ) : (
        <Box className={styles.containter}>
          <Box display={'flex'} justifyContent={'center'}>
            <HeaderPolicy title={t('privacyPolicy')} />
            <Box className={styles.content}>
              <h1 className={styles.titleHeader}>{t('privacyPolicy')}</h1>
              <h4 className={styles.titleParraf}>{t('DataControllerTitle')}</h4>
              <Typography className={styles.parraph}>{t('DataControllerParraf')}</Typography>
              <h4 className={styles.titleParraf}>{t('areaOfAplicationTitle')}</h4>
              <Typography className={styles.parraph}>{t('areaOfAplicationParraf')}</Typography>
              <h4 className={styles.titleParraf}>{t('PurposesTheCollectiontitle')}</h4>
              <Typography className={styles.parraph}>{t('PurposesTheCollectionParraf')}</Typography>
              <h4 className={styles.titleParraf}>{t('PeriodConservationTitle')}</h4>
              <Typography className={styles.parraph}>{t('PeriodConservationParraf')}</Typography>
              <h4 className={styles.titleParraf}>{t('RecipientsPersonalDataTitle')}</h4>
              <Typography className={styles.parraph}>
                {t('RecipientsPersonalDataParraf')}
              </Typography>
              <h4 className={styles.titleParraf}>{t('RightOfUsersTitle')}</h4>
              <Typography className={styles.parraph}>{t('RightOfUsersParraf')}</Typography>
              <h4 className={styles.titleParraf}>{t('ControlAuthorityTitle')}</h4>
              <Typography className={styles.parraph}>{t('ControlAuthorityParraf')}</Typography>
              <h4 className={styles.titleParraf}>{t('AicrumitDataProcessorTitle')}</h4>
              <Typography className={styles.parraph}>{t('AicrumitDataProcessorParraf')}</Typography>
              <h4 className={styles.titleParraf}>{t('InfoDataProtectionTitle')}</h4>
              <Typography className={styles.parraph}>{t('InfoDataProtectionParraf')}</Typography>
            </Box>
          </Box>
        </Box>
      )}
    </>
  )
}
